import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { nothing as w, html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './toast-notification.scss.js';

class ToastNotification extends s {
    constructor() {
        super(...arguments);
        this.variant = 'success';
        this.heading = '';
        this.message = '';
        this.closeLabel = 'Close notification';
        this.shrink = false;
        this.dismiss = () => {
            this.dispatchEvent(new CustomEvent('toast-dismiss', { bubbles: true, composed: true }));
        };
        this.pause = () => {
            this.clearTimers();
            this.shrink = false;
        };
        this.resume = () => {
            if (!this.durationMs)
                return;
            this.clearTimers();
            this.startFrame = requestAnimationFrame(() => {
                this.startFrame = requestAnimationFrame(() => {
                    this.shrink = true;
                });
            });
            this.dismissTimer = window.setTimeout(this.dismiss, this.durationMs);
        };
    }
    firstUpdated() {
        this.resume();
    }
    disconnectedCallback() {
        this.clearTimers();
        super.disconnectedCallback();
    }
    clearTimers() {
        if (this.dismissTimer)
            window.clearTimeout(this.dismissTimer);
        if (this.startFrame)
            cancelAnimationFrame(this.startFrame);
        this.dismissTimer = undefined;
        this.startFrame = undefined;
    }
    renderProgress(tone) {
        if (!this.durationMs)
            return w;
        const width = this.shrink ? 0 : 100;
        const duration = this.shrink ? this.durationMs : 0;
        const style = `width: ${width}%; transition-duration: ${duration}ms`;
        return $ `<div class="progress ${tone}" style="${style}"></div>`;
    }
    render() {
        const tone = this.variant === 'success' ? 'is-success' : 'is-error';
        return $ `<div class="card" @mouseenter="${this.pause}" @mouseleave="${this.resume}" @focusin="${this.pause}" @focusout="${this.resume}"><div class="body"><span class="material-symbols-outlined status ${tone}" aria-hidden="true">${this.variant === 'success' ? 'check_circle' : 'warning'}</span><div class="text"><p class="heading">${this.heading}</p><p class="message">${this.message}</p></div><button type="button" class="close" aria-label="${this.closeLabel}" @click="${this.dismiss}"><span class="material-symbols-outlined" aria-hidden="true">close</span></button></div>${this.renderProgress(tone)}</div>`;
    }
}
ToastNotification.styles = css_248z;
__decorate([
    e()
], ToastNotification.prototype, "variant", void 0);
__decorate([
    e()
], ToastNotification.prototype, "heading", void 0);
__decorate([
    e()
], ToastNotification.prototype, "message", void 0);
__decorate([
    e({ type: Number })
], ToastNotification.prototype, "durationMs", void 0);
__decorate([
    e()
], ToastNotification.prototype, "closeLabel", void 0);
__decorate([
    t()
], ToastNotification.prototype, "shrink", void 0);
customElements.define('toast-notification', ToastNotification);

export { ToastNotification };
